import { injectCpmsBoChannelsStatisticsApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-channels-statistics.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoChannelsStatisticsApi =
  injectCpmsBoChannelsStatisticsApi(baseApi);

export const { useCpmsBoGetChannelStatusesStatisticsQuery } =
  cpmsBoChannelsStatisticsApi;
